import {createElement, PropTypes} from 'rlink-react';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';

function ContentImg ({src, className, pathForContent, alt}) {
  return <img className={className} src={pathForContent(src)} alt={alt} />;
}

ContentImg.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  pathForContent: PropTypes.func,
  alt: PropTypes.string,
};

ContentImg.defaultProps = {
  alt: '',
};

export default connectToPathForContent(ContentImg);



// WEBPACK FOOTER //
// ./lib/rlink-repos/components/ContentImg.jsx